import { SvgIcon, SxProps, Theme } from "@mui/material"

export const ReadAllIcon = ({ onClick = () => { }, color = "#5C2DB3", sx = {} }: { onClick?: () => void, color?: string, sx?: SxProps<Theme> }) => {
    return (
        <SvgIcon
            onClick={onClick}
            viewBox="0 0 11 11"  // Adjust viewBox to tightly fit the icon
            sx={{
                width: 16,
                height: 16,
                ...sx
            }}
        >
            <path d="M2.07943 8.65348C1.85026 8.65348 1.65408 8.57189 1.49089 8.40869C1.32769 8.2455 1.24609 8.04932 1.24609 7.82015V2.82015C1.24609 2.59098 1.32769 2.3948 1.49089 2.23161C1.65408 2.06841 1.85026 1.98682 2.07943 1.98682H8.74609C8.97526 1.98682 9.17144 2.06841 9.33464 2.23161C9.49783 2.3948 9.57943 2.59098 9.57943 2.82015V7.82015C9.57943 8.04932 9.49783 8.2455 9.33464 8.40869C9.17144 8.57189 8.97526 8.65348 8.74609 8.65348H2.07943ZM5.41276 5.73682L2.07943 3.65348V7.82015H8.74609V3.65348L5.41276 5.73682ZM5.41276 4.90348L8.74609 2.82015H2.07943L5.41276 4.90348ZM2.07943 3.65348V2.82015V7.82015V3.65348Z" fill={color} />
        </SvgIcon>
    )
}